import { $ } from '../../../shared/js/utils/dom';
import Bus from '../../../shared/js/modules/event-bus';
import { isMobile } from '../../../shared/js/globals/breakpoints';

class NavStickyFlag {
  constructor(params) {
    this.el = params.el;
    this.toggleEl = $('.nav-sticky-flag__toggle', this.el);
    this.linkEl = $('.nav-sticky-flag__link', this.el);
    this.isExpanded = !isMobile;
    this.isInitial = true;
  }

  init() {
    this.eventBinding();
    if (this.linkEl) this.linkEl.setAttribute('id', 'nav-sticky-flag');
    this.mobileHandler();
  }

  eventBinding() {
    Bus.subscribe(
      'resize',
      'NavStickyFlagResize',
      this.resizeHandler.bind(this)
    );
  }

  expand() {
    this.isExpanded = true;
    this.el.classList.remove('nav-sticky-flag--collapsed');
    this.el.classList.add('nav-sticky-flag--expanded');
    this.toggleEl.setAttribute('aria-expanded', this.isExpanded);
    if (this.linkEl) {
      this.linkEl.setAttribute('aria-hidden', !this.isExpanded);
      this.linkEl.removeAttribute('tabindex');
    }
  }

  collapse() {
    this.isExpanded = false;
    this.el.classList.remove('nav-sticky-flag--expanded');
    this.el.classList.add('nav-sticky-flag--collapsed');
    this.toggleEl.setAttribute('aria-expanded', this.isExpanded);
    if (this.linkEl) {
      this.linkEl.setAttribute('aria-hidden', !this.isExpanded);
      this.linkEl.setAttribute('tabindex', '-1');
    }
  }

  toggle() {
    if (this.isInitial) this.isInitial = false;
    if (this.isExpanded) {
      this.collapse();
      return;
    }

    this.expand();
  }

  scrollHandler() {
    if (isMobile && this.isInitial && window.scrollY > 0) this.collapse();
  }

  resizeHandler() {
    this.mobileHandler();
  }

  mobileHandler() {
    if (isMobile) {
      this.addAria();
      this.toggleEl.addEventListener('click', this.toggle.bind(this));
      this.el.addEventListener('keyup', this.keyHandlerEsc.bind(this));
      Bus.subscribe(
        'scroll',
        'NavStickyFlagScroll',
        this.scrollHandler.bind(this)
      );
      // if (window.scrollY > 0) this.collapse();
      return;
    }

    this.removeAria();
    this.toggleEl.removeEventListener('click', this.toggle);
    this.el.removeEventListener('keyup', this.keyHandlerEsc);
    if (Bus.listeners.list.scroll)
      Bus.unsubscribe('scroll', 'NavStickyFlagScroll', this.scrollHandler);
    this.el.classList.remove('nav-sticky-flag--collapsed');
    this.el.classList.remove('nav-sticky-flag--expanded');
  }

  addAria() {
    this.toggleEl.setAttribute('aria-controls', 'nav-sticky-flag');
  }

  removeAria() {
    this.toggleEl.removeAttribute('aria-controls');
    this.toggleEl.removeAttribute('aria-expanded');
    if (this.linkEl) this.linkEl.removeAttribute('aria-hidden');
  }

  keyHandlerEsc(e) {
    if (e.key === 'Escape') {
      this.collapse();
      this.toggleEl.focus();
    }
  }
}

const el = $('.nav-sticky-flag');
const flagInstance = el ? new NavStickyFlag({ el }) : undefined;
flagInstance?.init();
